<template>
    <BModal :model-value="modal" centered @update:modelValue="updateModal" scrollable no-close-on-esc
        no-close-on-backdrop>
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Accomodation</h5>
                <BButton variant="link" class="close" @click="updateModal(false)">
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <BRow>
                <BCol>
                    <BFormGroup label="Destination *" label-for="destination" class="text-start mb-3">
                        <v-select v-model="form.destination" label="name" :options="destinationList" :searchable="true"
                            :clearable="true" placeholder="Select Destination" :loading="destinationLoading"
                            @open="getAllDestination" @option:selecting="getAllAccomodation" :class="{
                                'is-invalid':
                                    v$.form.destination_uuid.$dirty &&
                                    v$.form.destination_uuid.$invalid,
                            }" />
                        <BFormInvalidFeedback :state="v$.form.destination_uuid.$dirty &&
                            v$.form.destination_uuid.$invalid
                            ">
                            {{ v$.form.destination_uuid.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup label="Accomodation" label-for="accomodation" class="text-start mb-3">
                        <v-select v-model="selectedAccomodation"
                            :get-option-label="(item) => `${item.name}${item.room_type ? ' - ' + item.room_type : ''} (${item.pax} pax)`"
                            @option:selected="getAccomodation"
                            :options="accomodationList" :reduce="(item) => item.uuid"
                            :loading="accomodationLoading"
                            :searchable="true" :clearable="true" placeholder="Select Accomodation" />
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup label="Name *" label-for="name" class="text-start mb-3">
                        <BFormInput v-model="form.name" type="text" id="name" placeholder="Enter Name" :class="{
                            'is-invalid':
                                v$.form.name.$dirty &&
                                v$.form.name.$invalid,
                        }" />
                        <BFormInvalidFeedback :state="v$.form.name.$dirty && v$.form.name.$invalid
                            ">
                            {{ v$.form.name.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup label="Code *" label-for="code" class="text-start mb-3">
                        <BFormInput v-model="form.code" type="text" id="code" placeholder="Enter Code" :class="{
                            'is-invalid':
                                v$.form.code.$dirty &&
                                v$.form.code.$invalid,
                        }" />
                        <BFormInvalidFeedback :state="v$.form.code.$dirty && v$.form.code.$invalid
                            ">
                            {{ v$.form.code.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup label="Room Type" label-for="room_type" class="text-start mb-3">
                        <BFormInput v-model="form.room_type" type="text" id="room_type" placeholder="Enter Room Type"
                            :class="{
                                'is-invalid':
                                    v$.form.room_type.$dirty &&
                                    v$.form.room_type.$invalid,
                            }" />
                        <BFormInvalidFeedback :state="v$.form.room_type.$dirty &&
                            v$.form.room_type.$invalid
                            ">
                            {{ v$.form.room_type.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup label="Extra Bed" label-for="extra_bed" class="text-start mb-3">
                        <BFormCheckbox v-model="form.extra_bed" :value="1" :unchecked-value="0" class="ml-1"
                            @change="handleExtraBedChange" :class="{
                                'is-invalid':
                                    v$.form.extra_bed.$dirty &&
                                    v$.form.extra_bed.$invalid,
                            }">Extra Bed
                        </BFormCheckbox>
                        <BFormInvalidFeedback :state="v$.form.extra_bed.$dirty &&
                            v$.form.extra_bed.$invalid
                            ">
                            {{ v$.form.extra_bed.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup label="Pax *" label-for="pax" class="text-start mb-3">
                        <BFormInput v-model="form.pax" type="number" id="Pax" placeholder="Enter Pax"
                            @update:modelValue="calculateSubtotal" :class="{
                                'is-invalid':
                                    v$.form.pax.$dirty && v$.form.pax.$invalid,
                            }" />
                        <BFormInvalidFeedback :state="v$.form.pax.$dirty && v$.form.pax.$invalid">
                            {{ v$.form.pax.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup label="Price per Pax *" label-for="price" class="text-start mb-3">
                        <BFormInput v-model="form.price" type="number" id="price" placeholder="Enter Price"
                            @update:modelValue="calculateSubtotal" :class="{
                                'is-invalid':
                                    v$.form.price.$dirty &&
                                    v$.form.price.$invalid,
                            }" />
                        <BFormInvalidFeedback :state="v$.form.price.$dirty && v$.form.price.$invalid
                            ">
                            {{ v$.form.price.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup label="Subtotal *" label-for="sub_total" class="text-start mb-3">
                        <BFormInput v-model="form.sub_total" type="number" id="sub_total" placeholder="Subtotal"
                            @update:modelValue="calculatePrice" :class="{
                                'is-invalid':
                                    v$.form.sub_total.$dirty &&
                                    v$.form.sub_total.$invalid,
                            }" />
                        <BFormInvalidFeedback :state="v$.form.sub_total.$dirty && v$.form.sub_total.$invalid
                            ">
                            {{ v$.form.sub_total.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <template v-if="form.extra_bed == 1">
                <BRow>
                    <BCol>
                        <BFormGroup label="Extra Bed Price *" label-for="extra_bed_price" class="text-start mb-3">
                            <BFormInput v-model="form.extra_bed_price" type="number" id="extra_bed_price"
                                placeholder="Enter Price" @update:modelValue="calculateTotal" :class="{
                                    'is-invalid':
                                        v$.form.extra_bed_price.$dirty &&
                                        v$.form.extra_bed_price.$invalid,
                                }" />
                            <BFormInvalidFeedback :state="v$.form.extra_bed_price.$dirty &&
                                v$.form.extra_bed_price.$invalid
                                ">
                                {{
                                    v$.form.extra_bed_price.$errors[0]?.$message
                                }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormGroup label="Total Price" label-for="total_price" class="text-start mb-3">
                            <BFormInput v-model="form.total_price" type="number" id="total_price"
                                placeholder="Total Price" disabled />
                        </BFormGroup>
                    </BCol>
                </BRow>
            </template>
            <BRow>
                <BCol>
                    <BFormGroup label="Inclusion" label-for="inclusion" class="text-start mb-3">
                        <BFormTextarea v-model="form.inclusion" id="inclusion" placeholder="Enter Inclusion" :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.inclusion.$dirty && v$.form.inclusion.$invalid,
                            }" />
                        <BFormInvalidFeedback :state="v$.form.inclusion.$dirty && v$.form.inclusion.$invalid">
                            {{ v$.form.inclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup label="Exclusion" label-for="exclusion" class="text-start mb-3">
                        <BFormTextarea v-model="form.exclusion" id="exclusion" placeholder="Enter Exclusion" :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.exclusion.$dirty && v$.form.exclusion.$invalid,
                            }" />
                        <BFormInvalidFeedback :state="v$.form.exclusion.$dirty && v$.form.exclusion.$invalid">
                            {{ v$.form.exclusion.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction">Save</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch, ref } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormTextarea,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minValue, minLength, requiredIf } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { parseRupiah } from "@/utils/format";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
    defaultPax: Number,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    selectedAccomodation.value = null
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

// const filteredAccomodationList = computed(() => {
//     if (!form.pax) return accomodationList.value;
//     return accomodationList.value.filter(
//         (item) => item.pax == form.pax
//     );
// });

let selectedAccomodation = ref(null);

const formData = {
    uuid: "",
    destination_uuid: "",
    destination: "",
    name: "",
    code: "",
    pax: "",
    price: "",
    sub_total: "",
    extra_bed: "",
    extra_bed_price: "",
    total_price: "",
    room_type: "",
    inclusion: "",
    exclusion: "",
};

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        // jika props.selectedData != null (action edit)
        if (newData && Object.keys(newData).length > 0) {
            const accomodationData = {
                ...newData,
                destination_uuid: newData.destination?.uuid || null,
                price: parseRupiah(newData.price),
                extra_bed_price: newData.extra_bed_price
                    ? parseRupiah(newData.extra_bed_price)
                    : null,
            };
            Object.assign(form, { ...accomodationData });
        } else {
            Object.assign(form, { ...formData, pax: props.defaultPax || "" });
            // Initial calculation if needed
            if (form.pax && form.price) calculateSubtotal();
        }
    },
    { immediate: true }
);

const rules = {
    form: {
        destination_uuid: {
            required: helpers.withMessage("Destination is required", required),
        },
        destination: {
            required: helpers.withMessage("Destination is required", required),
        },
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3",
                minLength(3)
            ),
        },
        pax: {
            required: helpers.withMessage("Pax is required", required),
            minValue: helpers.withMessage(
                "Pax must be at least 1",
                minValue(1)
            ),
        },
        code: {
            required: helpers.withMessage("Code is required", required),
        },
        extra_bed: {},
        room_type: {
            // required: helpers.withMessage("Price is required", required),
        },
        price: {
            required: helpers.withMessage("Price is required", required),
            minValue: helpers.withMessage(
                "Price must be at least 1",
                minValue(1)
            ),
        },
        sub_total: {
            required: helpers.withMessage("Subtotal is required", required),
            minValue: helpers.withMessage(
                "Subtotal must be at least 1",
                minValue(1)
            ),
        },
        extra_bed_price: {
            requiredIf: helpers.withMessage(
                "Extra Bed Price is required",
                requiredIf(() => form.extra_bed == 1)
            ),
            minValue: helpers.withMessage(
                "Extra Bed Price must be at least 1",
                (val) => (form.extra_bed == 1 ? parseFloat(val) >= 1 : true)
            ),
        },
        inclusion: {},
        exclusion: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.index != undefined ? update() : create();
};

const create = async () => {
    toast.clear();
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            // Jka ada index hapus, index hanya jika edit
            const payload = { ...form };
            delete payload.index;
            emit("addOrUpdate", payload);
            toast.success("Accomodation added successfully");
            updateModal(false);
            resetForm();
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    toast.clear();
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            emit("addOrUpdate", {
                index: props.selectedData.index,
                ...form,
            });
            toast.success("Accomodation updated successfully");
            updateModal(false);
            resetForm();
        } finally {
            loader.hide();
        }
    }
};

let destinationList = ref([]);
let destinationLoading = ref(false)

const getAllDestination = async () => {
    if (destinationList.value.length > 0) return;
    destinationLoading.value = true;
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/destination`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            destinationList.value = res.data;
        }
    } finally {
        destinationLoading.value = false;
    }
};

let accomodationList = ref([]);
let accomodationLoading = ref(false);
const getAllAccomodation = async (destination) => {

    accomodationLoading.value = true
    form.destination = destination

    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/accomodation`,
            {
                params: {
                    'destination_uuid': destination.uuid
                },
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            selectedAccomodation.value = null;
            accomodationList.value = res.data && res.data.length ? res.data : [];
        }
    } finally {
        accomodationLoading.value = false;
    }
};

const getAccomodation = (accomodation) => {
    if (accomodation) {
        form.code = accomodation.code;
        form.name = accomodation.name;
        form.pax = accomodation.pax;
        form.extra_bed = accomodation.extra_bed;
        form.price = accomodation.price;
        form.extra_bed_price = accomodation.extra_bed_price || null;
        form.sub_total = accomodation.sub_total;
        form.total_price = accomodation.total_price;
        form.room_type = accomodation.room_type;
        form.inclusion = accomodation.inclusion;
        form.exclusion = accomodation.exclusion;
    } else {
        form.code = "";
        form.name = "";
        form.pax = "";
        form.extra_bed = "";
        form.price = "";
        form.extra_bed_price = "";
        form.sub_total = "";
        form.total_price = "";
        form.room_type = "";
        form.inclusion = "";
        form.exclusion = "";
    }
}

// Auto-adjust removed as per user request (pax should not change automatically)

watch(
    () => form.destination,
    (val) => {
        form.destination_uuid = val ? val.uuid : null;
    }
);

// Calculate total price when price or extra_bed_price changes
const calculateTotal = () => {
    const subTotal = parseFloat(form.sub_total) || 0;
    const extraBedPrice = form.extra_bed == 1 ? (parseFloat(form.extra_bed_price) || 0) : 0;
    form.total_price = subTotal + extraBedPrice;
};

const calculateSubtotal = () => {
    const pax = parseFloat(form.pax) || 0;
    const price = parseFloat(form.price) || 0;
    form.sub_total = pax * price;
    calculateTotal();
};

const calculatePrice = () => {
    const pax = parseFloat(form.pax) || 0;
    const subTotal = parseFloat(form.sub_total) || 0;

    if (pax && pax != 0 && subTotal) {
        form.price = Math.round(subTotal / pax);
    } else if (pax == 0 && subTotal) {
        // can't divide by zero
    } else {
        if (!subTotal) {
            form.price = 0;
        }
    }
    calculateTotal();
};

const handleExtraBedChange = (val) => {
    if (val != 1) {
        form.extra_bed_price = 0;
    }
    calculateTotal();
};

</script>
